import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    isTitle: true,
  },
  
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARDS.PRINCIPAL',
    icon: 'bx-home-circle',
    link: '/dashboard',
    permission: 'home.view',
  },
  
  {
    id: 3,
    label: 'MENUITEMS.Clients.Clients',
    icon: 'bx bx-user-pin',
    link: '/listclient',
    permission: 'clients.view',
  },
  {
    id: 40,
    label: 'MIS CRÉDITOS',
    icon: 'bx bxs-credit-card',
    link: '/my-credits',
    permission: 'portal.credits.view',
  },
  {
    id: 41,
    label: 'MIS TRANSACCIONES',
    icon: 'bx bx-transfer',
    link: '/my-transactions',
    permission: 'portal.transactions.view',
  },
  {
    id: 4,
    label: 'MENUITEMS.Credits.Credits',
    icon: 'bx bxs-credit-card', //https://velzon.2nclick.com/Icons/Boxicons?
    link: '/listcredits',
    permission: 'credits.view',
  },
  {
    id: 5,
    label: 'MENUITEMS.Payment.PaymentList',
    icon: 'bx-store',
    link: '/listpayments',
    permission: 'listpayments.view', // Note: Check if bails.view or wait... let's check listpayments.view vs bails.view
  },
  {
    id: 51,
    label: 'MENUITEMS.Payment.DisbursementList',
    icon: 'bx-transfer-alt',
    link: '/listdisbursements',
    permission: 'disbursements.view',
  },
  {
    id: 52,
    label: 'MENUITEMS.Payment.SettlementList',
    icon: 'bx-file',
    link: '/listsettlements',
    permission: 'settlements.view',
  },
  {
    id: 53,
    label: 'MENUITEMS.Payment.BailWithdrawals',
    icon: 'bx-wallet',
    link: '/bail-withdrawals',
    permission: 'bail.cash.view',
  },
  {
    id: 6,
    label: 'MENUITEMS.requests.requests',
    icon: 'bx bx-news',
    link: '/requests',
    permission: 'requests.view',
  },
  {
    id: 7,
    label: 'MARKETPLACE',
    icon: 'bx-circle',
    link: '/marketplace',
    permission: 'marketplace.view',
  },
  {
    id: 13,
    label: 'SIIGO',
    icon: 'bx-money',
    link: '/siigo',
    permission: 'siigo.view',
  },
  /* 
  {
    id: 12,
    label: 'MIS USUARIOS',
    icon: 'bx-user-circle',
    link: '/customer',
  },
  */
  {
    id: 8,
    label: 'ADMIN MENU',
    isTitle: true,
  },
  {
    id: 9,
    label: 'MENUITEMS.Users.Users',
    icon: 'bx bx-user',
    link: '/listuser',
    permission: 'users.view',
  },
  {
    id: 10,
    label: 'FIANZAS',
    icon: 'bx-home-circle',
    link: '/bails',
    permission: 'bails.view', // "Ver fianzas"
  },
  {
    id: 14,
    label: 'ROLES',
    icon: 'bx-shield-quarter',
    link: '/roles',
    permission: 'roles.view', // Check... if users.view covers it? Usually separate
  },
  {
    id: 11,
    label: 'MENUITEMS.config.config', // "CONFIGURACIÓN"
    icon: 'bx bxs-joystick-alt',
    permission: 'configuration.view',
    subItems: [
      {
        id: 41,
        label: 'GENERAL', // "General"
        link: '/config',
        permission: 'configuration.general.view',
      },
      {
        id: 42,
        label: 'COMISION', // "Comisión"
        link: '/commissions',
        permission: 'configuration.comission.view',
      },
    ],
  },
  {
    id: 12,
    label: 'MENUITEMS.Payment.Payment',
    icon: 'bx-store',
    link: '/payment',
  },
];

export const MENUADMIN: MenuItem[] = [
  {
    id: 1,
    label: 'ADMIN MENU',
    isTitle: true,
  },
  {
    id: 2,
    label: 'MENUITEMS.Users.Users',
    icon: 'bx bx-user',
    link: '/listuser',
  },
  {
    id: 3,
    label: 'FIANZAS',
    icon: 'bx-home-circle',
    link: '/bails',
  },
  {
    id: 4,
    label: 'MENUITEMS.config.config', // "CONFIGURACIÓN"
    icon: 'bx bxs-joystick-alt',
    subItems: [
      {
        id: 41,
        label: 'GENERAL', // "General"
        link: '/config',
      },
      {
        id: 42,
        label: 'COMISION', // "Comisión"
        link: '/commissions',
      },
    ],
  },
  {
    id: 5,
    label: 'MENUITEMS.Payment.Payment',
    icon: 'bx-store',
    link: '/payment',
  },
  {
    id: 6,
    label: 'ROLES',
    icon: 'bx-shield-quarter',
    link: '/roles',
  },
];
